export enum FlipColorSchemes {
  flipOrange = "flipOrange",
  goldenYellow = "goldenYellow",
  crimsonRed = "crimsonRed",
  jadeGreen = "jadeGreen",
  sapphireBlue = "sapphireBlue",
  mauvePurple = "mauvePurple",
}

export declare type IFlipColorSchemes = keyof typeof FlipColorSchemes;
